/* eslint-disable arrow-body-style */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";
import { useFormik, FormikProvider, useFormikContext } from "formik";
import * as Yup from "yup";
import { _ } from "ag-grid-community";
import {
  Box,
  ButtonPrimary,
  ButtonPrimary1,
  HStack,
} from "../../../components/utils";
import BasicExerciseDetails from "./BasicExerciseDetails";
import ExerciseDetails from "./ExerciseDetails";
import {
  defaultTransactionDetailsData,
  RecurringIntervalUnitV2,
  TransactionDetailsData,
} from "../../../types/Transaction";
import PersonnelListWithFilterDetails from "./PersonnelListDetails";
import PersonnelListUploaded from "./PersonnelListUploaded";
import PreviewExerciseDetails from "./PreviewExerciseDetails";
import TransactionStartedDetails from "./TransactionStartedDetails";
import SharesIssuanceDetails from "./SharesIssuanceDetails";
import ExerciseSummary from "./ExerciseSummary";
import { SelectBlackoutStep } from "./BlackOutDates";
import { saveTransactionDetails } from "../../../api/TransactionApisV2";

type ExerciseDetailsNavigationProps = {
  currentStep: number;
  validationSchemas: Yup.ObjectSchema<any>[];
  onStepChange: (e?: number) => void;
  onBackClick: () => void;
};

export function ExerciseDetailsNavigation(
  props: Readonly<ExerciseDetailsNavigationProps>
) {
  const { currentStep, onStepChange, onBackClick } = props;
  const formik = useFormikContext<TransactionDetailsData>();
  const considerBlackoutDays =
    formik.values.monetaryDetails?.considerBlackOutDays || false;

  return (
    <Box className="w-full h-full pb-4 mx-auto align-middle">
      <HStack>
        {currentStep === 1 && (
          <BasicExerciseDetails
            onBackClick={onBackClick}
            onStepChange={onStepChange}
          />
        )}
        {currentStep === 2 && (
          <ExerciseDetails
            onBackClick={onBackClick}
            onStepChange={onStepChange}
          />
        )}
        {currentStep === 3 &&
          formik.values.monetaryDetails?.considerBlackOutDays && (
            <SelectBlackoutStep
              onBackClick={onBackClick}
              onStepChange={onStepChange}
            />
          )}
        {currentStep === 4 &&
          ((formik.values.monetaryDetails.participantListMethod &&
            formik.values.monetaryDetails.participantListMethod) !==
          "Upload Excel" ? (
            <PersonnelListWithFilterDetails
              onBackClick={onBackClick}
              onStepChange={onStepChange}
            />
          ) : (
            <PersonnelListUploaded
              onBackClick={onBackClick}
              onStepChange={onStepChange}
            />
          ))}
        {currentStep === 5 && (
          <PreviewExerciseDetails
            validationSchemas={props.validationSchemas}
            onBackClick={onBackClick}
            onStepChange={onStepChange}
          />
        )}
        {currentStep === 6 && (
          <TransactionStartedDetails
            onBackClick={onBackClick}
            onStepChange={onStepChange}
          />
        )}
        {currentStep === 7 && (
          <SharesIssuanceDetails
            onBackClick={onBackClick}
            onStepChange={onStepChange}
          />
        )}
        {currentStep === 8 && (
          <ExerciseSummary
            onBackClick={onBackClick}
            onStepChange={onStepChange}
          />
        )}
      </HStack>
    </Box>
  );
}
